module.exports = __webpack_public_path__ + "img/40_38_030_960.61df6b0e.jpg";